import throttle from '~/utils/throttle';
import domodiEvents from '../utils/domodi-events.js';
import inViewPort from '../utils/in-view-port.js';

const ElementViewsTracker = (() => {

    const INTERVAL = 200;

    const ATTRIBUTE_NAME = 'data-sctr';

    const Selectors = {
        ITEM: `[${ATTRIBUTE_NAME}]`
    };

    const domodiEvent = (action, context) => {
        domodiEvents('similarProducts', action, context);
    };

    class ViewsTracker {
        constructor() {
            this.registry = [];
            this.handler = throttle(this.update.bind(this), INTERVAL);
            this.addEvents();
        }

        addEvents() {
            window.addEventListener('scroll', this.handler, {
                passive: true,
                capture: true
            });
            window.addEventListener('resize', this.handler, {
                passive: true,
                capture: true
            });
        }

        removeEvents() {
            window.removeEventListener('scroll', this.handler, {
                passive: true,
                capture: true
            });
            window.removeEventListener('resize', this.handler, {
                passive: true,
                capture: true
            });
        }

        update() {
            this.registerItems();
            this.check();
        }

        check() {
            this.registry.forEach((item) => {
                if (inViewPort(item.node) && !item.seen) {
                    item.seen = true;
                    domodiEvent('view', item.model);
                }
            });
        }

        findItemInRegistry(registry, model) {
            registry.find((item) => {
                const pid = item.model.productId === model.productId;
                const rid = item.model.refferalProductId === model.refferalProductId;
                return pid && rid;
            });
        }

        registerItems() {
            [].forEach.call(document.querySelectorAll(Selectors.ITEM), (item) => {
                const model = JSON.parse(item.getAttribute(ATTRIBUTE_NAME));
                const registered = this.findItemInRegistry(this.registry, model);

                if (model.productId && !registered) {
                    item.removeAttribute(ATTRIBUTE_NAME);
                    item.addEventListener('click', () => domodiEvent('click', model), false);
                    this.registry.push({ node: item, seen: false, model: model });
                }
            });
        }
    }

    return new ViewsTracker();

})();

export default ElementViewsTracker;
